import { type FC } from "react";

import { t } from "i18n/i18n.ts";

export const OptionalNote: FC = () => {
  return <span className="body-xs text-black-tint-40">{t("common.optional")}</span>;
};
